import { useOutletContext } from "react-router";
import CatalogSearchHandler from "../../../../../Components/Catalog/catalog-search-handler";
import { DbAssetObjectInfos } from "../../../../../Core/Api/Types/db-asset-object-infos";

function InventoryTitles() {
  // Outlet context used to pass props to parent DashboardLayout through react router dom
  const { selectedItems, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<DbAssetObjectInfos[]>>;
    selectedItems: DbAssetObjectInfos[];
  }>();

  return <CatalogSearchHandler selectedItems={selectedItems} setSelectedItems={setSelectedItems} />;
}

export default InventoryTitles;
